import React, { useState, useEffect } from "react";
import { useAuth } from "../App";
import Swal from "sweetalert2";

const HomePage = () => {
  const { api, showToast } = useAuth();
  const [signatures, setSignatures] = useState([]);
  const [stats, setStats] = useState({
    daily: 0,
    monthly: 0,
    yearly: 0,
    total: 0,
  });
  const [formData, setFormData] = useState({
    fullname: "",
    organization: "",
    province: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    loadSignatures();
    loadStatistics();
  }, [currentPage]);

  const loadSignatures = async () => {
    try {
      const response = await api.signatures.getAll({
        page: currentPage,
        limit: 10,
        status: "active",
      });
      setSignatures(response.data);
      setTotalPages(response.pagination.pages);
    } catch (error) {
      console.error("Error loading signatures:", error);
    }
  };

  const loadStatistics = async () => {
    try {
      // This would normally come from an API endpoint
      // For now, using mock data
      const mockStats = {
        daily: Math.floor(Math.random() * 50) + 100,
        monthly: Math.floor(Math.random() * 500) + 2000,
        yearly: Math.floor(Math.random() * 5000) + 10000,
        total: signatures.length || 1234,
      };
      setStats(mockStats);
    } catch (error) {
      console.error("Error loading statistics:", error);
    }
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.fullname || !formData.message) {
      await Swal.fire({
        icon: "warning",
        title: "กรุณากรอกข้อมูลให้ครบถ้วน",
        text: "โปรดกรอกชื่อ-นามสกุล และข้อความถวายพระพร",
        confirmButtonColor: "#007CC7",
      });
      return;
    }

    setLoading(true);

    try {
      const response = await api.signatures.create(formData);

      if (response.success) {
        await Swal.fire({
          icon: "success",
          title: "ลงนามสำเร็จ",
          text: "ขอบคุณที่ร่วมลงนามถวายพระพรชัยมงคล",
          confirmButtonColor: "#007CC7",
        });

        // Reset form
        setFormData({
          fullname: "",
          organization: "",
          province: "",
          message: "",
        });

        // Reload signatures
        loadSignatures();
        showToast("บันทึกการลงนามเรียบร้อยแล้ว");
      }
    } catch (error) {
      await Swal.fire({
        icon: "error",
        title: "เกิดข้อผิดพลาด",
        text: "ไม่สามารถบันทึกการลงนามได้ กรุณาลองใหม่อีกครั้ง",
        confirmButtonColor: "#007CC7",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="homepage">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="container">
          <div
            className="hero-content text-center animate__animated animate__fadeIn"
            style={{ marginTop: "300px" }}
          >
            <h1 className="display-4 fw-bold mb-3">ลงนามถวายพระพรชัยมงคล</h1>
            <h3 className="mb-4">
              สมเด็จพระนางเจ้าสิริกิติ์ พระบรมราชินีนาถ พระบรมราชชนนีพันปีหลวง
            </h3>
            <p className="lead" style={{ color: "blue" }}>
              เนื่องในโอกาสวันเฉลิมพระชนมพรรษา วันที่ ๑๒ สิงหาคม ๒๕๖๘
            </p>
            <div className="mt-4">
              <a href="#signature-form" className="btn btn-light btn-lg me-3">
                <i className="fas fa-signature"></i> ลงนามถวายพระพร
              </a>
              {/* <a href="#about" className="btn btn-outline-light btn-lg">
              <i className="fas fa-info-circle"></i> เกี่ยวกับระบบ
          </a> */}
            </div>
          </div>
        </div>
      </section>

      {/* Statistics Section */}
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="text-center mb-5">สถิติการเข้าใช้งานระบบ</h2>
          <div className="row g-4">
            <div className="col-md-3">
              <div className="info-box">
                <div className="info-box-icon bg-gradient-primary">
                  <i className="fas fa-calendar-day"></i>
                </div>
                <div className="info-box-content">
                  <h3>{stats.daily.toLocaleString()}</h3>
                  <p>ผู้เข้าชมวันนี้</p>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="info-box">
                <div className="info-box-icon bg-gradient-success">
                  <i className="fas fa-calendar-alt"></i>
                </div>
                <div className="info-box-content">
                  <h3>{stats.monthly.toLocaleString()}</h3>
                  <p>ผู้เข้าชมเดือนนี้</p>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="info-box">
                <div className="info-box-icon bg-gradient-warning">
                  <i className="fas fa-calendar"></i>
                </div>
                <div className="info-box-content">
                  <h3>{stats.yearly.toLocaleString()}</h3>
                  <p>ผู้เข้าชมปีนี้</p>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="info-box">
                <div className="info-box-icon bg-gradient-danger">
                  <i className="fas fa-users"></i>
                </div>
                <div className="info-box-content">
                  <h3>{stats.total.toLocaleString()}</h3>
                  <p>จำนวนผู้ลงนามทั้งหมด</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      {/* <section id="about" className="py-5">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <h2 className="mb-4">เกี่ยวกับระบบ</h2>
                            <p className="lead">
                                ระบบลงนามถวายพระพรชัยมงคลออนไลน์ พัฒนาขึ้นด้วยเทคโนโลยี AI และ Cloud Computing 
                                ที่ทันสมัย เพื่อให้ประชาชนทุกคนสามารถร่วมแสดงความจงรักภักดีได้อย่างสะดวกและปลอดภัย
                            </p>
                            <div className="accordion" id="featuresAccordion">
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                        <button className="accordion-button" type="button" 
                                                data-bs-toggle="collapse" 
                                                data-bs-target="#feature1">
                                            <i className="fas fa-rocket me-2"></i> เทคโนโลยี AI ขั้นสูง
                                        </button>
                                    </h2>
                                    <div id="feature1" className="accordion-collapse collapse show" 
                                         data-bs-parent="#featuresAccordion">
                                        <div className="accordion-body">
                                            ใช้ระบบ AI ในการวิเคราะห์และจัดการข้อมูล พร้อมระบบความปลอดภัยขั้นสูง
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                        <button className="accordion-button collapsed" type="button" 
                                                data-bs-toggle="collapse" 
                                                data-bs-target="#feature2">
                                            <i className="fas fa-cloud me-2"></i> Cloud Infrastructure
                                        </button>
                                    </h2>
                                    <div id="feature2" className="accordion-collapse collapse" 
                                         data-bs-parent="#featuresAccordion">
                                        <div className="accordion-body">
                                            ทำงานบน Cloud Platform ที่มีความเสถียรสูง รองรับผู้ใช้จำนวนมาก
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                        <button className="accordion-button collapsed" type="button" 
                                                data-bs-toggle="collapse" 
                                                data-bs-target="#feature3">
                                            <i className="fas fa-mobile-alt me-2"></i> Responsive Design
                                        </button>
                                    </h2>
                                    <div id="feature3" className="accordion-collapse collapse" 
                                         data-bs-parent="#featuresAccordion">
                                        <div className="accordion-body">
                                            รองรับการใช้งานทุกอุปกรณ์ ทั้งคอมพิวเตอร์ แท็บเล็ต และสมาร์ทโฟน
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <img src="https://via.placeholder.com/600x400/007CC7/ffffff?text=Royal+Wishes+System" 
                                 alt="System Preview" 
                                 className="img-fluid rounded shadow" />
                        </div>
                    </div>
                </div>
            </section> */}

      {/* Signature Form Section */}
      <section id="signature-form" className="py-5 bg-light">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="card shadow-lg">
                <div className="card-header card-header-gradient">
                  <h3 className="mb-0">
                    <i className="fas fa-signature me-2"></i>
                    ลงนามถวายพระพรชัยมงคล
                  </h3>
                </div>
                <div className="card-body p-4">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">
                          ชื่อ-นามสกุล <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="fullname"
                          value={formData.fullname}
                          onChange={handleInputChange}
                          placeholder="กรอกชื่อ-นามสกุล"
                          required
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">หน่วยงาน/องค์กร</label>
                        <input
                          type="text"
                          className="form-control"
                          name="organization"
                          value={formData.organization}
                          onChange={handleInputChange}
                          placeholder="กรอกหน่วยงาน (ถ้ามี)"
                        />
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">จังหวัด</label>
                      <input
                        type="text"
                        className="form-control"
                        name="province"
                        value={formData.province}
                        onChange={handleInputChange}
                        placeholder="กรอกจังหวัด"
                      />
                    </div>
                    <div className="mb-4">
                      <label className="form-label">
                        ข้อความถวายพระพร <span className="text-danger">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        name="message"
                        value={formData.message}
                        onChange={handleInputChange}
                        rows="4"
                        placeholder="กรอกข้อความถวายพระพรชัยมงคล"
                        required
                      ></textarea>
                    </div>
                    <div className="text-center">
                      <button
                        type="submit"
                        className="btn btn-gradient-primary btn-lg"
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2"></span>
                            กำลังบันทึก...
                          </>
                        ) : (
                          <>
                            <i className="fas fa-paper-plane me-2"></i>
                            ส่งลงนามถวายพระพร
                          </>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Signatures List Section */}
      <section id="signatures-list" className="py-5">
        <div className="container">
          <h2 className="text-center mb-5">รายชื่อผู้ลงนามถวายพระพร</h2>
          <div className="row">
            {signatures.map((signature, index) => (
              <div key={signature.id} className="col-md-6 mb-4 fade-in">
                <div className="card h-100">
                  <div className="card-body">
                    <div className="d-flex align-items-start">
                      <div className="bg-gradient-primary text-white rounded-circle p-3 me-3">
                        <i className="fas fa-user"></i>
                      </div>
                      <div className="flex-grow-1">
                        <h5 className="mb-1">{signature.fullname}</h5>
                        {signature.organization && (
                          <p className="text-muted small mb-1">
                            <i className="fas fa-building me-1"></i>
                            {signature.organization}
                          </p>
                        )}
                        {signature.province && (
                          <p className="text-muted small mb-2">
                            <i className="fas fa-map-marker-alt me-1"></i>
                            {signature.province}
                          </p>
                        )}
                        <p className="mb-0">{signature.message}</p>
                        <small className="text-muted">
                          {new Date(signature.created_at).toLocaleDateString(
                            "th-TH",
                            {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                            }
                          )}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <nav className="mt-4">
              <ul className="pagination justify-content-center">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => setCurrentPage(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    ก่อนหน้า
                  </button>
                </li>
                {[...Array(totalPages)].map((_, i) => (
                  <li
                    key={i + 1}
                    className={`page-item ${
                      currentPage === i + 1 ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage(i + 1)}
                    >
                      {i + 1}
                    </button>
                  </li>
                ))}
                <li
                  className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => setCurrentPage(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    ถัดไป
                  </button>
                </li>
              </ul>
            </nav>
          )}
        </div>
      </section>
    </div>
  );
};

export default HomePage;
